import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// tslint:disable-next-line:import-blacklist
import { BehaviorSubject } from 'rxjs';
import { CORPORATE } from '../util/constants';
import { NGaugeService } from './shared/ngauge.service';
import { UserService } from './user.service';
import { MatTableDataSource, MatDialog } from '@angular/material';
import { ShowGradeComponent } from '../shared-components/show-grade/show-grade.component';
import { AuthService } from './shared/auth.service';

@Injectable()
export class TechService {
  sideNavSub = new BehaviorSubject<any>(null);
  sideNav = this.sideNavSub.asObservable();
  closeSideNavSub = new BehaviorSubject<any>(null);
  closeSideNav = this.closeSideNavSub.asObservable();
  userinfo:any;
  constructor(
    private userService: UserService,
    private httpClient: HttpClient,
    private dialog: MatDialog,
    private authservice:AuthService,
    private ngaugeService: NGaugeService) { }

  publishSideNavTriggerer(option) {
    this.sideNavSub.next(option);
  }

  publishCloseSideNavTriggerer(value) {
    this.closeSideNavSub.next(value);
  }

  getFilterParams(orderByColumn) {
    this.userinfo=JSON.parse(sessionStorage.getItem('$$NGauge-UserInfo$$'));
    const orderBy = '"order":"' + orderByColumn + ' desc"';
    const commonFields = ['about', 'status', 'id','SID'];
    commonFields.push(orderByColumn);
    const columnFilter = '"fields":' + JSON.stringify(commonFields);
    // adding where condition to get only particular login sid data
    let whereCondition='';
    let filter=''
    if(sessionStorage.getItem('$$NGauge-Logged-In-Property$$') !="Yedla Management Company" ){
      whereCondition = '"where":{"SID":"'+JSON.parse(this.authservice.getSID())+'"}';
      filter = '{' + columnFilter + ',' + orderBy +','+whereCondition + '}';
    }
    else{
      if(this.userinfo.userType!="SuperAdmin"){
        whereCondition = '"where":{"SID":"'+JSON.parse(this.authservice.getSID())+'"}';
      filter = '{' + columnFilter + ',' + orderBy +','+whereCondition + '}';
      }
      else{
        filter = '{' + columnFilter + ',' + orderBy + '}';
      }
    }
    return { params: this.ngaugeService.getHttpParams(filter) };
  }

  getMatTable(data, paginator, sort) {
    paginator.pageIndex = 0;
    const dataSource = new MatTableDataSource(data);
    paginator.firstPage();
    paginator.length = data.length;
    dataSource.paginator = paginator;
    dataSource.sort = sort;
    return dataSource;
  }

  openGradeComponent(issue) {
    const params = { tellUsMore: issue['tellUsMore'], rateExperience: issue['rateExperience'] };
    return this.dialog.open(ShowGradeComponent, {
      width: '550px',
      height: '350px',
      data: { accept: 'Ok', reject: 'Cancel', value: params }
    });
  }

  getMoreAttributes(issue, result) {
    issue['tellUsMore'] = result['tellUsMore'];
    issue['rateExperience'] = result['rateExperience'];
    return issue;
  }

  getReportedIssues(params) {
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_REPORT_ISSUE'), params);
  }

  getReportIssueByPropertyId(id, property) {
    const propertyType = this.userService.getLoggedInPropertyType();
    // const uniqueField = propertyType === CORPORATE ? 'propertyreportId' : 'id';
    const uniqueField ='id';
    const whereFilter = '"where":{"and":[{"' + uniqueField + '":' + id + '},{"property": "' + property + '"}],"SID":"'+this.authservice.getSID()+'"}';
    const filter = '{' + whereFilter + '}';
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_REPORT_ISSUE'), params);
  }

  getReportIssueById(id) {
    const whereFilter = '"where":{"id":' + id +'}';
    const filter = '{' + whereFilter + '}';
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_REPORT_ISSUE'), params);
  }

  getSuggestEnhancements(params) {
    return this.httpClient.get(this.ngaugeService.getMeldURL('SUGGEST_ENHANCEMENT'), params);
  }

  getSuggestByPropertyId(id, property) {
    const propertyType = this.userService.getLoggedInPropertyType();
    // const uniqueField = propertyType === CORPORATE ? 'propertysuggestId' : 'id';
    const uniqueField ='id';
    const whereFilter = '"where":{"and":[{"' + uniqueField + '":' + id + '},{"property": "' + property + '"}],"SID":"'+this.authservice.getSID()+'"}';
    const filter = '{' + whereFilter + '}';
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('SUGGEST_ENHANCEMENT'), params);
  }

  getSuggestById(id) {
    const whereFilter = '"where":{"id":' + id +'}';
    const filter = '{' + whereFilter + '}';
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('SUGGEST_ENHANCEMENT'), params);
  }

  getAskQuestion(params) {
    return this.httpClient.get(this.ngaugeService.getMeldURL('ASK_QUESTION'), params);
  }

  getQuestionByPropertyId(id, property) {
    const propertyType = this.userService.getLoggedInPropertyType();
    // const uniqueField = propertyType === CORPORATE ? 'propertyaskId' : 'id';
    const uniqueField ='id';
    const whereFilter = '"where":{"and":[{"' + uniqueField + '":' + id + '},{"property": "' + property + '"}]}';
    const filter = '{' + whereFilter + '}';
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('ASK_QUESTION'), params);
  }

  getQuestionById(id) {
    const whereFilter = '"where":{"id":' + id + '}';
    const filter = '{' + whereFilter + '}';
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('ASK_QUESTION'), params);
  }

  saveReportIssue(value) {
    const propertyType = this.userService.getLoggedInPropertyType();
    // operation type for updatereport in CorporateDb/ propertyDb
    const operationType = propertyType === CORPORATE ? 'YMC_UPDATE_REPORT' : 'UPDATE_REPORT_ISSUE';
    const tableToUse = value['id'] === 0 ? 'CREATE_REPORT_ISSUE' : operationType;
    // if (tableToUse !='CREATE_REPORT_ISSUE'){
    //   if (!value['SID']){
    //     value['SID'] = this.authservice.getSID();
    //   }
    // }
    return this.httpClient.post(this.ngaugeService.getMeldURL(tableToUse), { reportinfo: value, SID : value.SID? value.SID : this.authservice.getSID() });
  }

  saveSuggestEnhancement(value) {
    const propertyType = this.userService.getLoggedInPropertyType();
    // operation type for updatesuggest in CorporateDb/ propertyDb
    const operationType = propertyType === CORPORATE ? 'YMC_UPDATE_SUGGEST' : 'UPDATE_SUGGEST_ENHANCEMENT';
    const tableToUse = value['id'] === 0 ? 'CREATE_SUGGEST_ENHANCEMENT' : operationType;
    // adding sid to body
    // if (tableToUse !='CREATE_SUGGEST_ENHANCEMENT'){
    //   if (!value['SID']){
    //     value['SID'] = this.authservice.getSID();
    //   }
    // }
    return this.httpClient.post(this.ngaugeService.getMeldURL(tableToUse), { suggestinfo: value , SID : value.SID? value.SID : this.authservice.getSID() });
  }

  saveAskQuestion(value) {
    const propertyType = this.userService.getLoggedInPropertyType();
    // operation type for updateask in CorporateDb/ propertyDb
    const operationType = propertyType === CORPORATE ? 'YMC_UPDATE_ASK' : 'UPDATE_ASK';
    const tableToUse = value['id'] === 0 ? 'CREATE_ASK' : operationType;
    // if (tableToUse !='CREATE_ASK'){
    //   if (!value['SID']){
    //     value['SID'] = this.authservice.getSID();
    //   }
    // }
    return this.httpClient.post(this.ngaugeService.getMeldURL(tableToUse), { askinfo: value,  SID : value.SID? value.SID : this.authservice.getSID() });
  }

  createJiraTicket(value) {
    return this.httpClient.post(this.ngaugeService.getMeldURL('YMC_CREATE_JIRA_TICKET'), { issueinfo: value });
  }

  updateTable(params) {
    const fromPage = params['from'];
    let tableName = '';
    delete params['from'];
    if (fromPage === 'report') {
      params = { reportinfo: params };
      tableName = 'YMC_UPDATE_REPORT';
    } else {
      params = { suggestinfo: params };
      tableName = 'YMC_UPDATE_SUGGEST';
    }
    return this.httpClient.post(this.ngaugeService.getMeldURL(tableName), params);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/tech.service.ts